import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination} from "../common";
import './Updates.css';

const Updates_3_46_0 = () => {
  return (
    <div>
      <PageTitle title='3.46.0' />

      <ParaTitle paraTitle='Email Reminders' />
      <Paragraph paragraph='2025-10-15' />

      <ParaTitle paraTitle='Added:' />
      <ul>
        <li>
          System reminders
          <p>The system automatically sends reminder emails to reviewers for aging reviews, including a generic message, a link to the TSN, and the number of days since assignment. Risk managers can control the frequency, enable or disable notifications, and set deadlines, helping them efficiently follow up on pending reviews.</p>
        </li>
        <li>
        Risk manager utilization report
          <p>Automatically send periodic emails to risk managers providing an overview of their facility’s performance, enabling them to monitor key metrics and stay informed on ongoing status.</p>
        </li>
        <li>
        Approver reminders
          <p>Automatically send email reminders to approvers listing pending items that require their approval, helping ensure timely review and decision-making.</p>
        </li>
        <li>
        Reviewer reminders
          <p>Automatically send reminders to reviewers about pending tasks, including relevant details and links, to ensure timely completion of assigned reviews.</p>
        </li>
      </ul>

      <Pagination
        pagination={{
          prev: { name: 'Updates: 3.47.0', link: '/updates/3.47.0' },
          next: { name: 'Events Summary', link: '/general/events-summary' }
        }}
      />
    </div>

  )
}

export default Updates_3_46_0;